/* Header + menu-overlay behavior. Vanilla, no deps, kept small for the JS
   budget (docs/design-system.md §11.4).
   GA4 theme event: menu_open (§11.5). Checkout-lifecycle events live in the
   Customer Events pixel, not here. */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  /* --- Transparent-over-hero: swap to solid paper once scrolled --- */
  if (header.classList.contains('al-header--transparent')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Menu overlay --- */
  var portal = document.querySelector('[data-menu-portal]');
  var openBtn = header.querySelector('[data-menu-open]');
  if (!portal || !openBtn) return;

  var closeBtn = portal.querySelector('[data-menu-close]');

  /* The header section is position: sticky with its own z-index, which caps
     everything inside it; the PDP's fixed add-to-cart bar sits above that
     and showed through the open menu (AS, 2026-09-12). Moving the portal to
     body lets its z-index count at the root. */
  if (portal.parentNode !== document.body) document.body.appendChild(portal);

  /* "More below" cue: on while the body can scroll and sits at the top. */
  var scrollBody = portal.querySelector('[data-menu-scroll]');
  function updateCue() {
    if (!scrollBody) return;
    var more = scrollBody.scrollHeight - scrollBody.clientHeight > 24 && scrollBody.scrollTop < 8;
    portal.classList.toggle('has-more', more);
  }
  if (scrollBody) scrollBody.addEventListener('scroll', updateCue, { passive: true });
  window.addEventListener('resize', updateCue);

  function openMenu() {
    portal.hidden = false;
    updateCue();
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    ga('menu_open', {});
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    portal.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    openBtn.focus();
  }

  openBtn.addEventListener('click', openMenu);
  portal.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !portal.hidden) closeMenu();
  });
})();
